import { createSlice } from '@reduxjs/toolkit'

export const onLoadStudentReducer = (state, { payload }) => {
  const { student } = payload

  const newState = {
    ...state,
    student
  }
  return newState
}

export const unloadStudentReducer = (state) => {
  const newState = {
    ...state,
    student: {
      id: null,
      username: null,
      firstName: null,
      lastName: null
    }
  }

  return newState
}

const studentSlice = createSlice({
  name: 'student',
  initialState: {
    student: {
      id: null,
      username: null,
      firstName: null,
      lastName: null
    }
  },
  reducers: {
    onLoadStudent: onLoadStudentReducer,
    unloadStudent: unloadStudentReducer
  }
})

const { actions, reducer } = studentSlice

export const {
  onLoadStudent,
  unloadStudent
} = actions

export default reducer
